import * as React from "react";

import { cn } from "../../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClass?: string;
  error?: string;
  icon?: React.ReactNode;
  isRequired?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, label, labelClass, isRequired, error, icon, ...props },
    ref
  ) => {
    return (
      <div className="flex flex-col">
        {label && (
          <span
            className={cn(
              "BookEZ_font_body_size BookEZ_font_light_bold BookEZ_font_color_gray_2 px-2 py-0.5 rounded",
              labelClass
            )}
          >
            {label} {isRequired && <span className="BookEZ_error_text">*</span>}
          </span>
        )}
        <div className="relative">
          <input
            type={type}
            className={cn(
              "flex h-10 w-full BookEZ_card_bg BookEZ_input_border_radius px-3 py-2 BookEZ_font_body_size ring-offset-background file:border-0 file:bg-transparent file:BookEZ_font_body_size file:BookEZ_font_normal BookEZ_font_color_gray_2 placeholder:BookEZ_font_color_gray_2 focus:outline-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200",
              "border", // always apply border
              "BookEZ_card_border_color", // base border color
              error && "BookEZ_error_border shadow-[0_0_0_1px_red]",
              icon && "pr-10",
              className
            )}
            ref={ref}
            {...props}
          />
          {icon && (
            <span className="h-4 w-4 absolute right-3 top-1/2 -translate-y-1/2 flex items-center pointer-events-none text-gray-400 disabled:cursor-not-allowed">
              {icon}
            </span>
          )}
        </div>
        {error && (
          <span className="BookEZ_font_body_size font-medium BookEZ_error_text">
            {error}
          </span>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
